import gql from 'graphql-tag';

import agentLogRowPartFragment from './agentLogRowPartFragment';

export const agentLogRowFragment = gql`
  fragment agentLogRowFragment on AgentLogRow {
    role
    conversationUserPromptID
    parts {
      ...agentLogRowPartFragment
    }
  }
  ${agentLogRowPartFragment}
`;
export default agentLogRowFragment;
